const {client, loadToken} = require('services/api/client');
export { loadToken };

export async function getAllClearways() {
  var { data } = await client.get(`/clearways/event`);
  return data;
}

export async function getClearwaysWithYearAndMonth(year, month) {
  // console.log(client)
  var { data } = await client.get(`/clearways/year/${year}/month/${month}`);
  return data;
}

export async function getClearwayEventWithID(id) {
  var { data } = await client.get(`/clearways/event/${id}`);
  return data;
}

export async function saveClearwayEventWithID(id, data) {
  var { data } = await client.put(`/clearways/event/${id}`, data);
  return data;
}

export async function createClearwayEvent(data){
  await client.post('clearways/event', data);
}

export async function checkClearwayDuplicateEvent(id, body){
  var { data } = await client.post(`/clearways/duplicate/${id}`, body);
  return data;
}

export async function deleteSelectedEvent(event_id){
  var { data } = await client.put(`/clearways/event/soft-delete/${event_id}`);
  return data;
}

export async function getClearwaysBetweenTimes(start_time, end_time) {
  var { data } = await client.get(`/clearways/start/${start_time}/end/${end_time}`);
  return data;
}

const all = {
  loadToken, getAllClearways, getClearwaysWithYearAndMonth, getClearwayEventWithID, saveClearwayEventWithID, createClearwayEvent, checkClearwayDuplicateEvent, deleteSelectedEvent, getClearwaysBetweenTimes
};

export default all;